function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.17 7.01c1.9-.88 4.08.5 4.08 2.61v21.84c0 .95-.46 1.83-1.24 2.37-3.22 2.2-6.68 3.67-11 3.67-3.2 0-5.82-.87-8.28-1.7-2.2-.73-4.29-1.43-6.55-1.43-4.57 0-7.74.9-10.28 2v8.47c0 1.2-.96 2.16-2.15 2.16H5.3a2.16 2.16 0 01-2.16-2.16V10.16a5.03 5.03 0 117.57-2.33 17.44 17.44 0 016.11-1.08c3.2 0 5.82.87 8.29 1.7 2.2.73 4.28 1.43 6.55 1.43 3.63 0 7.41-1.43 10.5-2.87zm-18.55 7.4a1.92 1.92 0 113.84 0v5.76h5.74a1.92 1.92 0 110 3.83h-5.74v5.75a1.92 1.92 0 01-3.84 0V24h-5.74a1.92 1.92 0 110-3.83h5.75v-5.75z"
})));